export default __webpack_public_path__ + "static/media/USDA.4bf972ae.svg";